<script setup>
import * as L from "leaflet"
import "leaflet.markercluster"
import { onMounted } from "vue"

let webmap
const props = defineProps(["stations"])

const fillMarkers = async () => {
  try {
    const markers = new L.MarkerClusterGroup()
    props.stations.forEach((s) => {
      const marker = L.marker([s.lat, s.lng]).bindPopup(s.description)
      markers.addLayer(marker)
    })
    markers.addTo(webmap)
    webmap.fitBounds(markers.getBounds(), { padding: [67, 67] })
  } catch (err) {
    console.log(err.message)
  }
}

onMounted(() => {
  if (!webmap) webmap = L.map("webmap").setView([0, 0], 2)

  L.tileLayer("https://{s}.basemaps.cartocdn.com/rastertiles/voyager_labels_under/{z}/{x}/{y}{r}.png", {
    maxZoom: 10,
    attribution: "© OpenStreetMap",
  }).addTo(webmap)

  fillMarkers()
})
</script>

<template>
  <div class="map-chart">
    <div id="webmap"></div>
  </div>
</template>
